(function () {
  'use strict';

  // On the CART PAGE (not in the drawer), a packaging switch causes a full page reload
  // (see performCartMutation below) - during this, the Pickeasy widget and our own UI
  // rebuild in several steps, visibly "jumping" around. Here, at the very START of the
  // script, BEFORE ANYTHING ELSE (so it runs as early as possible, before the user can
  // notice a flash), we bridge this with a cover, if the sessionStorage flag coming
  // from the previous page indicates we're right after such a reload.
  var CART_RELOAD_PENDING_KEY = 'vk_cart_reload_pending';
  var CART_RELOAD_HEIGHT_KEY = 'vk_cart_reload_height';
  var CART_RELOAD_SCROLL_KEY = 'vk_cart_reload_scroll';
  var cartPageReloadOverlayTargets = [];

  // On location.reload() the browser (unlike back/forward navigation) always jumps to
  // the top of the page - if the customer switched packaging on a lower item, this
  // causes a jarring "jump". So before the switch (see performCartMutation) we save the
  // current scroll position, and restore it here as soon as possible. The "manual"
  // scrollRestoration is needed so the browser's own (back/forward-navigation)
  // restoration attempt doesn't interfere with our own logic here.
  try {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  } catch (e) {}

  var pendingScrollY = null;

  // Restoring the scroll position ONCE (or a few times, at fixed points) isn't enough:
  // the Pickeasy widget's own rebuild, independent of us (see below, a ~1-1.3 second
  // phenomenon), or even the browser itself, can reset it to 0 at any time, POSSIBLY
  // even AFTER our earlier (load-time) attempt. So we maintain a "lock" here: on every
  // DOM change (anywhere on the page, not just in the covered area) we re-set the
  // position, until the customer starts scrolling themselves (at which point we give up
  // immediately - we don't want a page "glued" to a given point), or until an upper time
  // limit runs out.
  var SCROLL_LOCK_MAX_WAIT_MS = 4000;
  var scrollLockActive = false;
  var scrollLockDeadline = 0;
  var scrollLockObserver = null;

  function releaseScrollLock() {
    scrollLockActive = false;
    if (scrollLockObserver) {
      scrollLockObserver.disconnect();
      scrollLockObserver = null;
    }
  }

  function reassertPendingScroll() {
    if (pendingScrollY == null) return;
    if (window.scrollY !== pendingScrollY) window.scrollTo(0, pendingScrollY);
  }

  function armScrollLock(scrollY) {
    pendingScrollY = scrollY;
    scrollLockActive = true;
    scrollLockDeadline = Date.now() + SCROLL_LOCK_MAX_WAIT_MS;

    reassertPendingScroll();

    // If the customer tries to scroll themselves, we immediately give up the lock -
    // otherwise we'd be overriding their own scroll, which would be worse UX than the
    // problem we're trying to fix.
    window.addEventListener('wheel', releaseScrollLock, { passive: true, once: true });
    window.addEventListener('touchmove', releaseScrollLock, { passive: true, once: true });
    window.addEventListener('load', reassertPendingScroll, { once: true });

    scrollLockObserver = new MutationObserver(function () {
      if (!scrollLockActive) return;
      if (Date.now() > scrollLockDeadline) {
        releaseScrollLock();
        return;
      }
      reassertPendingScroll();
    });
    scrollLockObserver.observe(document.body, { childList: true, subtree: true, attributes: true });

    setTimeout(releaseScrollLock, SCROLL_LOCK_MAX_WAIT_MS);
  }

  (function coverCartPageReloadArea() {
    var pending = false;
    var storedHeight = null;
    var storedScroll = null;
    try {
      pending = sessionStorage.getItem(CART_RELOAD_PENDING_KEY) === '1';
      storedHeight = sessionStorage.getItem(CART_RELOAD_HEIGHT_KEY);
      storedScroll = sessionStorage.getItem(CART_RELOAD_SCROLL_KEY);
      if (pending) {
        sessionStorage.removeItem(CART_RELOAD_PENDING_KEY);
        sessionStorage.removeItem(CART_RELOAD_HEIGHT_KEY);
        sessionStorage.removeItem(CART_RELOAD_SCROLL_KEY);
      }
    } catch (e) {
      // sessionStorage not available -> we simply don't cover, the feature still works
    }
    if (!pending) return;

    if (storedScroll) armScrollLock(parseInt(storedScroll, 10));

    var buyButtonsTarget = document.querySelector('.cart-page .buy-buttons--main');
    if (!buyButtonsTarget) return;

    if (storedHeight) buyButtonsTarget.style.minHeight = storedHeight + 'px';
    buyButtonsTarget.classList.add('packaging-overlay-cover', 'packaging-overlay-cover--spinner');
    cartPageReloadOverlayTargets.push(buyButtonsTarget);
  })();

  function hideCartPageReloadOverlay() {
    if (!cartPageReloadOverlayTargets.length) return;
    cartPageReloadOverlayTargets.forEach(function (target) {
      target.classList.remove('packaging-overlay-cover', 'packaging-overlay-cover--spinner');
      target.style.minHeight = '';
    });
    cartPageReloadOverlayTargets = [];
    // By the time we get here, the Pickeasy widget and our own UI have settled for
    // good - we still keep the scroll lock alive for a bit longer (see armScrollLock),
    // because the widget can sometimes move the scroll EVEN AFTER this; here we just do
    // one last, immediate correction, we don't release the lock prematurely.
    reassertPendingScroll();
  }

  // Even AFTER the initial sync() completes (the packaging picker builds up), it's not
  // certain everything has settled: following our synthetic click to restore Personal
  // pickup, the Pickeasy widget can re-render itself on its OWN schedule, independent of
  // us (see reconcilePickeasySelection below) - the same phenomenon as in the drawer
  // (see OVERLAY_QUIET_MS/OVERLAY_MAX_WAIT_MS there). Here too: we only remove the cover
  // once no further DOM change happens within the section for a while (350ms), but at
  // the latest after 2.5 seconds regardless.
  function watchCartPageReloadOverlay() {
    var targets = cartPageReloadOverlayTargets;
    if (!targets.length) return;

    var deadline = Date.now() + 2500;
    var hideTimer = null;
    var observer = new MutationObserver(function (records) {
      var relevant = records.some(function (r) {
        return targets.some(function (target) { return target.contains(r.target) || r.target === target; });
      });
      if (relevant) arm();
    });

    function arm() {
      clearTimeout(hideTimer);
      var wait = Math.min(350, Math.max(deadline - Date.now(), 0));
      hideTimer = setTimeout(function () {
        observer.disconnect();
        hideCartPageReloadOverlay();
      }, wait);
    }

    observer.observe(document.body, { childList: true, subtree: true, attributes: true });
    arm();
  }

  // This is the actual Shopify option NAME (currently not translatable, per earlier
  // check) -> it stays Hungarian, because it's needed for data matching (cart.js
  // options_with_values[].name). The labels actually shown are given by the STRINGS
  // object below, per language.
  var PACKAGING_OPTION_NAME = 'Helyben fogyasztod, vagy elviszed?';

  // The button/heading text is our own UI element, not Shopify data, so we translate it
  // here, and the label is consistent with the English translation of the variant
  // values (see "No box" / "Gift box (+600 Ft)" on the product's option values).
  var LOCALE = ((window.Shopify && Shopify.locale) || document.documentElement.lang || 'hu').slice(0, 2).toLowerCase();
  var STRINGS = LOCALE === 'en' ? {
    heading: 'Eat in, or take away?',
    helperText: '(You can change this above, per item, anytime.)',
    base: "I'll eat it here",
    addon: "I'll take it",
    qtyUnit: 'pcs',
    splitOneBase: '+ Also add one to eat in',
    splitOneAddon: '+ Also add one to take away'
  } : {
    heading: 'Helyben fogyasztod, vagy elviszed?',
    helperText: '(Fentebb, tételenként bármikor módosíthatod a döntésed.)',
    base: 'Helyben fogyasztom',
    addon: 'Elviszem',
    qtyUnit: 'db',
    splitOneBase: '+ Kérek belőle egyet helyben fogyasztásra is',
    splitOneAddon: '+ Kérek belőle egyet elvitelre is'
  };

  var PRODUCT_CACHE_KEY = 'vk_pkg_product_cache_v2';

  var packagingInfoCache = {};

  // Which products have a "Helyben fogyasztod, vagy elviszed?" option, and what the two
  // variant ids are (base / +600 Ft). This rarely changes, so we also store it in
  // localStorage, so we don't need to call /products/{handle}.js on every page load.
  function readProductCache() {
    try {
      return JSON.parse(localStorage.getItem(PRODUCT_CACHE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function writeProductCache(handle, info) {
    try {
      var cache = readProductCache();
      cache[handle] = info;
      localStorage.setItem(PRODUCT_CACHE_KEY, JSON.stringify(cache));
    } catch (e) {
      // localStorage not available -> silently skip
    }
  }

  function getHandleFromUrl(url) {
    if (!url) return null;
    try {
      var path = url.split('?')[0];
      var parts = path.split('/').filter(Boolean);
      var idx = parts.indexOf('products');
      return idx > -1 && parts[idx + 1] ? parts[idx + 1] : null;
    } catch (e) {
      return null;
    }
  }

  var HTML_ESCAPE_MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (c) { return HTML_ESCAPE_MAP[c]; });
  }

  // Returns:
  // - { baseVariantId, addonVariantId }, if the product has a "Helyben fogyasztod, vagy
  //   elviszed?" option (the choice involves swapping variants, see swapWholeLine),
  // - { propertyOnly: true }, if it has no such option, but is tagged "kurtoskalacs" (in
  //   this case there's no box surcharge/separate variant, but at the customer's
  //   request the choice still needs to be offered and recorded - see
  //   swapPropertyChoice - because it's good to know how they'd like it),
  // - null otherwise (the product isn't affected at all).
  function getPackagingInfo(handle) {
    if (!handle) return Promise.resolve(null);
    if (packagingInfoCache.hasOwnProperty(handle)) {
      return Promise.resolve(packagingInfoCache[handle]);
    }
    // We only take a POSITIVE (non-null) prior result at face value from localStorage -
    // we ignore a null entry (possibly left over from an older code version, see the
    // note further below at the save point) and re-fetch instead, so a possibly only
    // transiently wrong/stale response doesn't get stuck permanently.
    var persisted = readProductCache();
    if (persisted.hasOwnProperty(handle) && persisted[handle]) {
      packagingInfoCache[handle] = persisted[handle];
      return Promise.resolve(persisted[handle]);
    }
    return fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('product fetch failed: ' + handle);
        return res.json();
      })
      .then(function (product) {
        var info = null;
        var options = product.options || [];
        var optionIndex = -1;

        // In the /products/{handle}.js response, "options" is an array of objects
        // ({name, position, values}), not a plain string array -> we need to search by
        // name, not indexOf.
        for (var i = 0; i < options.length; i++) {
          if (options[i] && options[i].name === PACKAGING_OPTION_NAME) {
            optionIndex = i;
            break;
          }
        }

        if (optionIndex > -1) {
          var optionKey = 'option' + (optionIndex + 1);

          // The option VALUE's text (e.g. "Díszdobozban (+600 Ft)") is translatable, so
          // an entirely different string comes back for an English-language customer ->
          // we distinguish the two variants not by text, but by price (the boxed
          // version is always more expensive, by +600 Ft), which is stable regardless
          // of language.
          var candidates = (product.variants || []).filter(function (variant) {
            return variant[optionKey] != null;
          });

          if (candidates.length === 2) {
            candidates.sort(function (a, b) { return a.price - b.price; });
            info = { baseVariantId: candidates[0].id, addonVariantId: candidates[1].id };
          }
        }

        if (!info && (product.tags || []).indexOf('kurtoskalacs') > -1) {
          info = { propertyOnly: true };
        }

        // IMPORTANT: we NEVER cache a null (= "this product has no packaging choice")
        // result, neither in memory nor in localStorage. Bug observed in production
        // (see user feedback: for a "kurtoskalacs"-tagged product, the toggle
        // disappeared entirely, in a way not fixed even by a page refresh): if the
        // /products/{handle}.js response returns incomplete/stale data even just ONCE
        // (e.g. a CDN cache's momentary delay for a recently modified product), the
        // null result looked like a correct answer, and it would have gotten stuck
        // PERMANENTLY in localStorage, across every further page load (refresh), in an
        // "incorrectly not eligible" state - the customer would not have been able to
        // fix it with any click or refresh, only by manually clearing the browser's
        // localStorage. A positive (non-null) result, by contrast, is stable, based on
        // actual product data, so we keep caching that.
        if (info) {
          packagingInfoCache[handle] = info;
          writeProductCache(handle, info);
        }
        return info;
      })
      .catch(function (err) {
        console.warn('[packaging-fulfillment-sync] Nem sikerült lekérni a terméket:', handle, err);
        return null;
      });
  }

  // The Pickeasy widget re-renders after every cart change (ours included), and loses
  // its previous selection in the process -> the "active" class then sits on its own
  // default (delivery) briefly (or persistently), REGARDLESS of what the customer
  // actually picked earlier. If we re-read this class on every sync(), our own
  // "delivery -> forced boxed version" step would interpret exactly this rendering
  // side-effect as "the customer requested delivery", and would immediately write back
  // the personal-pickup choice (see user feedback: the "Helyben fogyasztom" button
  // "wouldn't let itself be checked"). So we track the ACTUAL click in our own state,
  // not the live DOM class.
  // On the CART PAGE (not in the drawer), a packaging switch is followed by a full page
  // reload (see performCartMutation below) - this also clears the confirmedFulfillmentType
  // held in a plain JS variable, since the new page load starts with a fresh JS context.
  // Because of this, after the reload the widget reset back to "Budapesti kiszállítás",
  // REGARDLESS of the customer having chosen Personal pickup earlier. So we ALSO store the
  // choice in sessionStorage, and read it back on page load - this way the reload survives
  // the choice, the same way the plain JS variable alone was enough in the drawer (where
  // there's no reload).
  var FULFILLMENT_TYPE_STORAGE_KEY = 'vk_confirmed_fulfillment_type';

  function readStoredFulfillmentType() {
    try {
      return sessionStorage.getItem(FULFILLMENT_TYPE_STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function writeStoredFulfillmentType(type) {
    try {
      sessionStorage.setItem(FULFILLMENT_TYPE_STORAGE_KEY, type);
    } catch (e) {
      // sessionStorage not available -> silently skip, the JS variable still works
      // (it just won't survive a possible reload)
    }
  }

  var confirmedFulfillmentType = readStoredFulfillmentType(); // 'pickup' | 'delivery' | null (not yet chosen)

  function mapOptionToFulfillmentType(dataOption) {
    if (dataOption === 'pickup') return 'pickup';
    if (dataOption === 'delivery' || dataOption === 'shipping') return 'delivery';
    return null;
  }

  // We listen in the capture phase (not bubble), because the Pickeasy widget's own click
  // handler probably calls stopPropagation() during bubbling -> in the bubble phase a
  // listener attached to document would never receive this click, even though the widget
  // visibly still reacts to it.
  document.addEventListener('click', function (event) {
    var optionEl = event.target.closest && event.target.closest('.ft-options[data-option]');
    if (!optionEl) return;
    var type = mapOptionToFulfillmentType(optionEl.getAttribute('data-option'));
    if (!type) return;
    confirmedFulfillmentType = type;
    writeStoredFulfillmentType(type);
    setTimeout(sync, 250);
  }, true);

  // Cheap, client-side pre-filter (doesn't call /products/{handle}.js): true if the line
  // item definitely has a variant-swap packaging option, OR if it's a Kürtőskalács
  // product (product_type - /cart.js RETURNS this field, no separate fetch needed), so
  // it could also qualify for property-only marking (see getPackagingInfo). The FINAL
  // decision (whether there's actually any packaging to handle) is made by
  // getPackagingInfo below.
  function isPackagingEligible(item) {
    var hasVariantOption = (item.options_with_values || []).some(function (ov) {
      return ov.name === PACKAGING_OPTION_NAME;
    });
    return hasVariantOption || item.product_type === 'Kürtőskalács';
  }

  // On a packaging switch, it's NOT just the footer (Pickeasy widget, checkout button)
  // that can jump around, but the cart-items list too (price, variant text re-render) -
  // so we cover the drawer's ENTIRE content (every top-level child except the header:
  // items, recap, warnings, cross-sells, footer) until the cart change and the
  // re-render that follows it are done - the customer should only ever see the
  // "settled", final state, never the in-between jumping ANYWHERE. Since these elements
  // can themselves get recreated along the way (the drawer's content gets replaced with
  // server HTML), we keep the state NOT in the DOM, but in these variables, and
  // re-apply it at every relevant moment. We only show the spinner icon on the last
  // (footer) element, so multiple don't appear scattered at once.
  var footerOverlayActive = false;
  var lockedHeights = null; // array of numbers, in the same order as getDrawerOverlayTargets()

  // After OUR mutation, the Pickeasy widget rebuilds itself on ITS OWN schedule,
  // independent of us (with separate network calls) - this is measurably (~1-1.3
  // seconds in production) slower than our own sync() (which only waits for a single
  // /cart.js call). If we removed the overlay right after sync() (or even after a
  // short fixed wait), the customer could see the widget's not-yet-settled, half-rebuilt
  // state (e.g. a picker visible for a moment, or the loyalty box shifting/its border
  // showing), BEFORE it settles for good. So we do NOT remove the overlay after a fixed
  // time, but wait until no further DOM change happens inside the drawer for a short
  // while (OVERLAY_QUIET_MS) - every further mutation inside the drawer restarts this
  // quiet-wait. An upper limit (OVERLAY_MAX_WAIT_MS) guards against the case where the
  // widget (e.g. because of some continuous background mutation independent of it)
  // never quiets down - in that case we also remove the overlay, at the latest after
  // this much time.
  var OVERLAY_QUIET_MS = 350;
  var OVERLAY_MAX_WAIT_MS = 2500;
  var overlayHidePending = false;
  var overlayHideTimer = null;
  var overlayHideDeadlineTs = 0;

  function getDrawerOverlayTargets() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return [];
    return Array.from(drawer.children).filter(function (child) {
      return child.getAttribute('slot') !== 'header';
    });
  }

  // TRIED AND DROPPED: a single overlay covering the whole area with position:fixed -
  // the cart-drawer's inner (shadow-DOM) sliding wrapper applies some kind of
  // transform, so the on-screen coordinates measured with getBoundingClientRect() AND
  // the same coordinates set on a position:fixed element do NOT get drawn in the same
  // place (measured offset: about +1444px) - position:fixed in this case positions
  // relative to the transformed ancestor, not the viewport. So we stick with the
  // per-element ::before cover (see theme.css), just also overriding the element's OWN
  // background color (not just the ::before's) - this way, even behind a possible
  // few-pixel rounding gap, the correct (matching) color shows through, not the
  // element's own, differently-shaded background/border.
  function applyFooterOverlayState() {
    var targets = getDrawerOverlayTargets();
    targets.forEach(function (el, index) {
      el.classList.toggle('packaging-overlay-cover', footerOverlayActive);
      el.classList.toggle('packaging-overlay-cover--spinner', footerOverlayActive && index === targets.length - 1);
      var locked = footerOverlayActive && lockedHeights ? lockedHeights[index] : null;
      el.style.minHeight = locked != null ? locked + 'px' : '';
    });
  }

  function showFooterOverlay() {
    overlayHidePending = false;
    clearTimeout(overlayHideTimer);
    if (!footerOverlayActive) {
      lockedHeights = getDrawerOverlayTargets().map(function (el) {
        return el.getBoundingClientRect().height;
      });
    }
    footerOverlayActive = true;
    applyFooterOverlayState();
  }

  function hideFooterOverlay() {
    overlayHidePending = false;
    clearTimeout(overlayHideTimer);
    footerOverlayActive = false;
    lockedHeights = null;
    applyFooterOverlayState();
  }

  function armOverlayHideTimer() {
    clearTimeout(overlayHideTimer);
    var wait = Math.min(OVERLAY_QUIET_MS, Math.max(overlayHideDeadlineTs - Date.now(), 0));
    overlayHideTimer = setTimeout(hideFooterOverlay, wait);
  }

  // The caller HERE only "requests" the overlay be removed - the actual removal only
  // happens once no further DOM mutation arrives within the drawer for a while
  // (OVERLAY_QUIET_MS) (see the restart in the MutationObserver below), or once the
  // OVERLAY_MAX_WAIT_MS upper limit expires.
  function requestOverlayHide() {
    overlayHidePending = true;
    overlayHideDeadlineTs = Date.now() + OVERLAY_MAX_WAIT_MS;
    armOverlayHideTimer();
  }

  function clearAllSlots() {
    document.querySelectorAll('.packaging-choice-slot').forEach(function (slot) {
      slot.innerHTML = '';
      // Without clearing the signature, renderSlot() would later incorrectly see the
      // same variant/quantity as "no change", and would leave the slot empty.
      slot.removeAttribute('data-rendered-signature');
      slot.removeAttribute('aria-busy');
    });

    document.querySelectorAll('.packaging-choices-summary').forEach(function (summary) {
      summary.innerHTML = '';
      summary.removeAttribute('data-rendered-signature');
    });
  }

  // Runs one or more cart/change.js + cart/add.js calls in sequence, in line with the
  // theme's own "cart:prepare-bundled-sections" / "cart:change" events, so the theme's
  // own logic refreshes the drawer (or cart page) afterward. This is ALSO called by the
  // silent, automatic "delivery -> forced boxed version" step (where there's no visible
  // packaging UI, so showing an overlay would be pointless), so it does NOT itself
  // manage the loading overlay - that's applied by performVisibleCartMutation() below,
  // which is specifically for user-click-triggered calls.
  function performCartMutation(mutations, useReload) {
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    var chain = Promise.resolve();
    var lastJson = null;

    mutations.forEach(function (mutation, index) {
      var isLast = index === mutations.length - 1;

      chain = chain.then(function () {
        var body = mutation.body;
        if (isLast) {
          body = Object.assign({}, body, { sections: sectionsToBundle.join(',') });
        }

        return fetch(Shopify.routes.root + 'cart/' + mutation.endpoint + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (res) {
          if (!isLast) return null;
          return res.json().then(function (json) {
            lastJson = json;
          });
        });
      });
    });

    return chain
      .then(function () {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

        // useReload does NOT indicate WHICH PAGE we're on, but rather which surface
        // (the cart page's own summary, or the drawer's own summary) the change
        // started from - see renderSummaryInto below. If we simply looked at the global
        // pageType, a switch started from a DRAWER OPENED ON THE CART PAGE would also
        // trigger a full page reload (since pageType is 'cart' there too), which "kills"
        // the drawer mid-action - the customer would see this as a forever-loading
        // drawer (clicking the switch button reloaded the whole page instead of the
        // drawer, and the drawer's own overlay state, held in a JS variable, was lost
        // as a result).
        if (useReload === undefined) {
          useReload = !!(window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart');
        }

        if (useReload) {
          // On the CART PAGE (unlike the drawer), a packaging switch is followed by a
          // full page reload - during this, the Pickeasy widget and our own UI also
          // rebuild, settling in several visibly "jumping" steps (first the default
          // state flashes, then the restored Personal pickup, then the packaging picker,
          // etc.). We bridge this at the very START of the script (see
          // coverCartPageReloadArea() below) with a cover - so that the NEW page load
          // also knows it needs to cover, here, BEFORE THE REFRESH, we save this intent
          // (and the current height, so it doesn't jump under the cover either) to
          // sessionStorage. We also save the current scroll position - location.reload()
          // (unlike back/forward navigation) always jumps to the top of the page, which
          // would be jarring for a customer switching on a lower item.
          try {
            var buyButtonsGroup = document.querySelector('.cart-page .buy-buttons--main');
            if (buyButtonsGroup) {
              sessionStorage.setItem(CART_RELOAD_HEIGHT_KEY, String(buyButtonsGroup.getBoundingClientRect().height));
            }
            sessionStorage.setItem(CART_RELOAD_SCROLL_KEY, String(window.scrollY));
            sessionStorage.setItem(CART_RELOAD_PENDING_KEY, '1');
          } catch (e) {
            // sessionStorage not available -> there won't be a cover after the reload,
            // but the feature itself (the swap) still completes correctly.
          }
          window.location.reload();
          return;
        }

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'line-item:change', cart: lastJson }
          })
        );
      })
      .catch(function (err) {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        // On error, no further renderSlot() runs to remove the "loading" state -> we
        // clear it manually here, so the buttons don't stay stuck behind a spinner icon
        // forever.
        document.querySelectorAll('.packaging-choice-slot[aria-busy="true"]').forEach(function (s) {
          s.removeAttribute('aria-busy');
        });
        console.warn('[packaging-fulfillment-sync] Kosár-módosítás sikertelen:', err);
      });
  }

  // This is the entry point specifically for switches triggered by a user click
  // (per-line/global toggle, split): it covers the footer with an overlay until the
  // mutation AND the full UI refresh that follows it (sync()) are done, only then does
  // it switch back to the final, "settled" state. "cart:change" also starts the theme's
  // own sync() (document listener) synchronously at dispatch time, but that itself is
  // async (fetch-based) -> so here we EXPLICITLY call sync() too (the function is
  // guaranteed to wait for any in-progress/meanwhile-joined cycle as well), and we only
  // remove the overlay after THAT fully completes.
  // mutationsOrBuilder can be a plain mutations array, OR a function that returns a
  // Promise resolving to such an array (see buildReorderedCartMutations below) - the
  // latter is needed because order-preserving swap operations FIRST need to fetch the
  // cart's FRESH, current state (/cart.js), and only then can the mutations be
  // assembled.
  function performVisibleCartMutation(mutationsOrBuilder, useReload) {
    showFooterOverlay();
    var mutationsPromise = typeof mutationsOrBuilder === 'function'
      ? mutationsOrBuilder()
      : Promise.resolve(mutationsOrBuilder);
    return mutationsPromise
      .then(function (mutations) { return performCartMutation(mutations, useReload); })
      .then(function () { return sync(); })
      .then(function () { requestOverlayHide(); })
      .catch(function () { hideFooterOverlay(); }); // performCartMutation already logged/cleared the busy state
  }

  // A simple "change quantity 0 + add" would always append the newly-added line to the
  // END of the cart - if the customer switched packaging on a lower item, they'd see
  // that item suddenly jump to the bottom/top of the list, with the other items
  // shifting. Instead, we rebuild the WHOLE cart with a /cart/clear.js + a single
  // /cart/add.js call that preserves the EXISTING order: every line stays in its old
  // place, only the swapped (targetKey) line's place gets the 1 or 2 new lines returned
  // by replacementBuilder (2 in the split case: the original with reduced quantity +
  // the newly split-off 1 piece).
  function buildReorderedCartItems(cartItems, targetKey, replacementBuilder) {
    var result = [];
    cartItems.forEach(function (current) {
      if (current.key !== targetKey) {
        result.push({ id: current.variant_id, quantity: current.quantity, properties: current.properties || {} });
        return;
      }
      replacementBuilder(current).forEach(function (spec) { result.push(spec); });
    });
    return result;
  }

  // IMPORTANT phenomenon, empirically verified (repeatedly, with several product
  // combinations) on this store: AFTER a /cart/add.js call, the cart ends up in the
  // REVERSED order of the submitted "items" array (the last-given line ends up first) -
  // regardless of whether it's a single (bulk) or several, sequential add.js calls. So
  // for every order-preserving rebuild we submit the desired final order REVERSED, so
  // that after the store's own reversal, exactly the desired order results.
  function reverseForCartAdd(items) {
    return items.slice().reverse();
  }

  // The mutations-builder that goes with buildReorderedCartItems above: fetches the
  // cart's fresh state, then returns a clear + add pair with the order preserved.
  function buildReorderedCartMutations(targetKey, replacementBuilder) {
    return fetch(Shopify.routes.root + 'cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var items = buildReorderedCartItems(cart.items || [], targetKey, replacementBuilder);
        return [
          { endpoint: 'clear', body: {} },
          { endpoint: 'add', body: { items: reverseForCartAdd(items) } }
        ];
      });
  }

  function swapWholeLine(item, targetVariantId, useReload) {
    if (String(targetVariantId) === String(item.variant_id)) return;
    performVisibleCartMutation(function () {
      return buildReorderedCartMutations(item.key, function (current) {
        return [{ id: parseInt(targetVariantId, 10), quantity: current.quantity, properties: current.properties || {} }];
      });
    }, useReload);
  }

  function splitLine(item, targetVariantId, useReload) {
    if (item.quantity <= 1) return;
    performVisibleCartMutation(function () {
      return buildReorderedCartMutations(item.key, function (current) {
        return [
          { id: current.variant_id, quantity: current.quantity - 1, properties: current.properties || {} },
          { id: parseInt(targetVariantId, 10), quantity: 1, properties: current.properties || {} }
        ];
      });
    }, useReload);
  }

  // For property-only products (no variant, tagged "kurtoskalacs"), the choice is
  // recorded not by swapping variants, but through the line's PROPERTIES: the
  // "_packaging_choice" hidden (underscore-prefixed) property is the MACHINE state
  // (this decides which button is active, see below - line-item.liquid already skips
  // hidden properties from display anyway), while the property named
  // PACKAGING_OPTION_NAME is the VISIBLE value, shown to the customer/on the order too
  // (the same label a real option value would have) - line-item.liquid already handled
  // this property name specially (shows the bare value, without a "key: " prefix, as if
  // it were a native option).
  function buildPackagingProperties(item, flag) {
    var properties = Object.assign({}, item.properties || {});
    properties._packaging_choice = flag;
    properties[PACKAGING_OPTION_NAME] = flag === 'base' ? STRINGS.base : STRINGS.addon;
    return properties;
  }

  function swapPropertyChoice(item, targetFlag, useReload) {
    var currentFlag = (item.properties && item.properties._packaging_choice) || 'addon';
    if (targetFlag === currentFlag) return;
    performVisibleCartMutation(function () {
      return buildReorderedCartMutations(item.key, function (current) {
        return [{ id: current.variant_id, quantity: current.quantity, properties: buildPackagingProperties(current, targetFlag) }];
      });
    }, useReload);
  }

  function splitPropertyChoice(item, targetFlag, useReload) {
    if (item.quantity <= 1) return;
    performVisibleCartMutation(function () {
      return buildReorderedCartMutations(item.key, function (current) {
        return [
          { id: current.variant_id, quantity: current.quantity - 1, properties: current.properties || {} },
          { id: current.variant_id, quantity: 1, properties: buildPackagingProperties(current, targetFlag) }
        ];
      });
    }, useReload);
  }

  // If the customer earlier (on personal pickup) set a property-only line's "Helyben
  // fogyasztom"/"Elviszem" property, and then in the meantime switched to delivery (or
  // hasn't picked a shipping method at all yet), this property would still remain on the
  // line - and would MISLEADINGLY keep showing on the cart/order, even though it's no
  // longer relevant (the customer would see this leftover "Helyben fogyasztom" label on
  // a line where the personal-pickup toggle wasn't even active). So in this case we
  // clear the property - it resets to "not set". Order preservation matters here too
  // (see buildReorderedCartItems), so we likewise do a full (but order-preserving) cart
  // rebuild, not a simple change+add.
  function buildClearedPropertiesSpec(item) {
    if (!item.properties || !item.properties._packaging_choice) return null;
    var clearedProperties = Object.assign({}, item.properties);
    delete clearedProperties._packaging_choice;
    delete clearedProperties[PACKAGING_OPTION_NAME];
    return { id: item.variant_id, quantity: item.quantity, properties: clearedProperties };
  }

  // The HTML for the "Helyben fogyasztod" / "Elviszed" button pair + (if quantity > 1)
  // the split link - this is what renderSlot() puts under every affected cart line.
  // For variant-swap products, the buttons swap the variant (data-action="toggle"); for
  // property-only products (see getPackagingInfo, info.propertyOnly), just the line's
  // properties (data-action="toggle-property") - from the customer's point of view, the
  // two cases look the same.
  function buildToggleMarkup(item, info) {
    if (info.propertyOnly) {
      var currentFlag = (item.properties && item.properties._packaging_choice) || 'addon';
      var currentIsAddon = currentFlag !== 'base';

      var propHtml = '<div class="packaging-line-toggle" role="group" aria-label="' + STRINGS.heading + '">' +
        '<button type="button" class="packaging-line-toggle__btn' + (currentIsAddon ? '' : ' is-selected') + '" data-action="toggle-property" data-target="base">' + STRINGS.base + '</button>' +
        '<button type="button" class="packaging-line-toggle__btn' + (currentIsAddon ? ' is-selected' : '') + '" data-action="toggle-property" data-target="addon">' + STRINGS.addon + '</button>' +
        '</div>';

      if (item.quantity > 1) {
        var otherFlag = currentIsAddon ? 'base' : 'addon';
        var propSplitLabel = currentIsAddon ? STRINGS.splitOneBase : STRINGS.splitOneAddon;
        propHtml += '<button type="button" class="packaging-line-toggle__split" data-action="split-property" data-target="' + otherFlag + '">' + propSplitLabel + '</button>';
      }

      return propHtml;
    }

    var currentIsAddon = String(item.variant_id) === String(info.addonVariantId);

    var html = '<div class="packaging-line-toggle" role="group" aria-label="' + STRINGS.heading + '">' +
      '<button type="button" class="packaging-line-toggle__btn' + (currentIsAddon ? '' : ' is-selected') + '" data-action="toggle" data-target="' + info.baseVariantId + '">' + STRINGS.base + '</button>' +
      '<button type="button" class="packaging-line-toggle__btn' + (currentIsAddon ? ' is-selected' : '') + '" data-action="toggle" data-target="' + info.addonVariantId + '">' + STRINGS.addon + '</button>' +
      '</div>';

    if (item.quantity > 1) {
      var otherVariantId = currentIsAddon ? info.baseVariantId : info.addonVariantId;
      var splitLabel = currentIsAddon ? STRINGS.splitOneBase : STRINGS.splitOneAddon;
      html += '<button type="button" class="packaging-line-toggle__split" data-action="split" data-target="' + otherVariantId + '">' + splitLabel + '</button>';
    }

    return html;
  }

  function bindToggleHandlers(container, item, onBusy, useReload, info) {
    if (info && info.propertyOnly) {
      container.querySelectorAll('[data-action="toggle-property"]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var targetFlag = btn.getAttribute('data-target');
          var currentFlag = (item.properties && item.properties._packaging_choice) || 'addon';
          if (targetFlag === currentFlag) return;
          onBusy();
          swapPropertyChoice(item, targetFlag, useReload);
        });
      });

      var propSplitBtn = container.querySelector('[data-action="split-property"]');
      if (propSplitBtn) {
        propSplitBtn.addEventListener('click', function () {
          onBusy();
          splitPropertyChoice(item, propSplitBtn.getAttribute('data-target'), useReload);
        });
      }
      return;
    }

    container.querySelectorAll('[data-action="toggle"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        // If the button points to the ALREADY active variant, swapWholeLine() below
        // wouldn't do anything anyway (nothing to swap) - but then nothing would EVER
        // run to remove the aria-busy set here, and the button would stay stuck in
        // "loading" state forever (see user feedback: "switching between box and eat-in
        // just keeps loading"). So we filter this case out up front, before even
        // marking it "busy".
        var targetVariantId = btn.getAttribute('data-target');
        if (String(targetVariantId) === String(item.variant_id)) return;
        onBusy();
        swapWholeLine(item, targetVariantId, useReload);
      });
    });

    var splitBtn = container.querySelector('[data-action="split"]');
    if (splitBtn) {
      splitBtn.addEventListener('click', function () {
        onBusy();
        splitLine(item, splitBtn.getAttribute('data-target'), useReload);
      });
    }
  }

  // The "Proceed to checkout" button group (.buy-buttons--main) does NOT only contain
  // the checkout button: the Pickeasy widget (<pickeasy-app-widget>) inserts itself
  // into THIS group too, as the FIRST child, before the checkout button. So the summary
  // must not go BEFORE the group, but INSIDE the group, directly before the checkout
  // button, so it falls between the widget AND the checkout button. Every call
  // repositions it (the widget sometimes re-inserts itself back at the start/end of the
  // group), the repeated insertBefore just moves the existing element, it doesn't
  // create a duplicate.
  //
  // It appears the same way both in the drawer AND on the cart page (/cart), as a
  // shared, INFORMATIONAL summary above the checkout button (the actual per-line choice
  // happens under the cart items, see renderSlot() below). .buy-buttons--main can exist
  // in the DOM in both places at once (e.g. the drawer's markup is in the DOM even when
  // it's closed) - so we look for all of them, and put each its OWN (separately
  // existing DOM element) summary.
  //
  // The PRODUCT PAGE (and the sticky "add to cart" bar) also has its own
  // .buy-buttons--main, but there this summary is unnecessary (at the customer's
  // request) - so we deliberately narrow the search to just the cart page and the
  // drawer, not the whole document.
  function getSummaryContainers() {
    return Array.from(document.querySelectorAll('.cart-page .buy-buttons--main, cart-drawer .buy-buttons--main')).map(function (buyButtonsGroup) {
      var checkoutButton = buyButtonsGroup.querySelector('button[type="submit"]') || buyButtonsGroup.lastElementChild;
      if (!checkoutButton) return null;

      var summary = buyButtonsGroup.querySelector('.packaging-choices-summary');
      if (!summary) {
        summary = document.createElement('div');
        summary.className = 'packaging-choices-summary';
      }
      buyButtonsGroup.insertBefore(summary, checkoutButton);
      return summary;
    }).filter(Boolean);
  }

  // Per-line toggle (under the cart line, only for personal pickup): the customer can
  // decide per product/line item whether that piece is eaten on the spot or taken away
  // - this is the actual control, not the shared summary above the checkout button (see
  // renderSummaryInto below, which only informs, doesn't let you choose).
  function renderSlot(item, info) {
    document.querySelectorAll('.packaging-choice-slot[data-line-item-key="' + item.key + '"]').forEach(function (slot) {
      // For property-only lines, the variant_id NEVER changes on a switch (only the
      // _packaging_choice property does) - the signature must also include this,
      // otherwise after a button switch the slot would incorrectly see the fresh state
      // as "no change".
      var choiceFlag = (item.properties && item.properties._packaging_choice) || '';
      var signature = item.variant_id + ':' + item.quantity + ':' + choiceFlag;
      if (slot.getAttribute('data-rendered-signature') === signature) return;
      slot.setAttribute('data-rendered-signature', signature);

      // Which surface a click on a button bound here starts from: the cart PAGE's own
      // line item (requires a full page reload, see performCartMutation), or the
      // drawer's (never a reload) - see the useReload note at performCartMutation.
      var useReload = !!slot.closest('.cart-page');

      slot.innerHTML = buildToggleMarkup(item, info);
      bindToggleHandlers(slot, item, function () {
        slot.setAttribute('aria-busy', 'true');
      }, useReload, info);
    });
  }

  // Shared summary above the checkout button: no longer lets you choose (the per-line
  // buttons do that, see renderSlot), only informs - lists, per line, which choice
  // (Helyben fogyasztom / Elviszem) is currently in effect for the affected cart items,
  // so the customer can take in the whole picture at a glance before checkout.
  function renderSummary(entries) {
    getSummaryContainers().forEach(function (summary) {
      renderSummaryInto(summary, entries);
    });
  }

  function renderSummaryInto(summary, entries) {
    if (!entries.length) {
      summary.innerHTML = '';
      summary.removeAttribute('data-rendered-signature');
      return;
    }

    var signature = entries
      .map(function (e) {
        var choiceFlag = (e.item.properties && e.item.properties._packaging_choice) || '';
        return e.item.key + ':' + e.item.variant_id + ':' + e.item.quantity + ':' + choiceFlag;
      })
      .join('|');
    if (summary.getAttribute('data-rendered-signature') === signature) return;
    summary.setAttribute('data-rendered-signature', signature);

    // Displayed grouped by choice (not line-by-line per product in "Product: Choice"
    // form), so the customer can see at a glance how many/which items fall into one
    // group, and how many/which into the other.
    var baseNames = [];
    var addonNames = [];
    entries.forEach(function (e) {
      var title = e.item.product_title || e.item.title;
      var qtySuffix = e.item.quantity > 1 ? ' (' + e.item.quantity + ' ' + STRINGS.qtyUnit + ')' : '';
      var label = title + qtySuffix;
      var isAddon = e.info.propertyOnly
        ? ((e.item.properties && e.item.properties._packaging_choice) || 'addon') !== 'base'
        : String(e.item.variant_id) === String(e.info.addonVariantId);
      (isAddon ? addonNames : baseNames).push(label);
    });

    function buildGroup(choiceLabel, names) {
      if (!names.length) return '';
      return '<div class="packaging-choices-summary__group">' +
        '<p class="packaging-choices-summary__choice">' + escapeHtml(choiceLabel) + '</p>' +
        '<ul class="packaging-choices-summary__note-list">' +
        names.map(function (name) { return '<li>' + escapeHtml(name) + '</li>'; }).join('') +
        '</ul>' +
        '</div>';
    }

    var html = '<p class="packaging-choices-summary__heading">' + STRINGS.heading + '</p>' +
      '<p class="packaging-choices-summary__helper">' + STRINGS.helperText + '</p>' +
      buildGroup(STRINGS.base, baseNames) +
      buildGroup(STRINGS.addon, addonNames);

    summary.innerHTML = html;
  }

  // The Pickeasy widget's own re-render (after any cart change, our packaging switch
  // included) resets itself not just visually, but ACTUALLY, to "Budapesti
  // kiszállítás", REGARDLESS of the customer having chosen "Személyes átvétel"
  // earlier. If we let this stand, the order would go through as delivery without the
  // customer's knowledge. So on every sync() we check: if OUR last confirmed choice is
  // "pickup", but the widget still doesn't show it as active, we restore the widget's
  // own state too with a synthetic click.
  //
  // On the CART PAGE (not in the drawer), the Pickeasy widget is present in the DOM in
  // duplicate (one hidden + one visible instance, with the same "pickup-option-div" id)
  // - getElementById would always only return the FIRST one (possibly the hidden one),
  // which meant the visible widget never received the restoring click. So we go through
  // every element with a matching id, and only click the ones that are actually visible.
  //
  // We do NOT decide VISIBILITY via offsetParent: INSIDE the drawer (because of
  // cart-drawer's own shadow-DOM-based sliding layer), even an actually visible,
  // real-sized element's offsetParent can be null (a Chrome quirk: the nearest
  // positioned ancestor is beyond the slot/shadow boundary) - because of this, this
  // condition would ALWAYS have evaluated to true in the drawer, and restoring personal
  // pickup would never have run there (what the user saw: in the drawer, after a
  // switch, the shipping method jumped back to "Budapesti kiszállítás"). Instead we
  // look at the ACTUAL rendered size - a genuinely hidden (e.g. display:none duplicate)
  // instance has no extent.
  function reconcilePickeasySelection() {
    if (confirmedFulfillmentType !== 'pickup') return;
    document.querySelectorAll('#pickup-option-div').forEach(function (pickupEl) {
      if (pickupEl.classList.contains('ft-options-active')) return;
      var rect = pickupEl.getBoundingClientRect();
      if (!rect.width && !rect.height) return; // hidden (e.g. duplicate) instance - skip
      pickupEl.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    });
  }

  var syncInProgress = false;
  var syncQueued = false;
  var syncPromise = Promise.resolve();

  // The returned promise only resolves once the CURRENT (or, if called again in the
  // meantime, the resulting subsequent) cycle has ACTUALLY finished - this way the
  // caller (e.g. performCartMutation) can reliably wait until our UI has also fully
  // refreshed, before doing anything (e.g. removing the loading overlay).
  function sync() {
    if (syncInProgress) {
      syncQueued = true;
      return syncPromise;
    }
    syncInProgress = true;

    syncPromise = fetch(Shopify.routes.root + 'cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        reconcilePickeasySelection();

        var eligibleItems = (cart.items || []).filter(isPackagingEligible);

        if (!eligibleItems.length) {
          clearAllSlots();
          return;
        }

        var fulfillment = confirmedFulfillmentType;

        if (fulfillment === 'delivery') {
          clearAllSlots(); // on delivery there's no choice, the boxed version always goes

          return Promise.all(
            eligibleItems.map(function (item) {
              var handle = getHandleFromUrl(item.url);
              return getPackagingInfo(handle).then(function (info) { return { item: item, info: info }; });
            })
          ).then(function (results) {
            var infoByKey = {};
            results.forEach(function (r) { if (r.info) infoByKey[r.item.key] = r.info; });

            // We rebuild the WHOLE cart, preserving the existing order (see the note at
            // buildReorderedCartItems) - a simple change+add would always append the
            // switched line to the END of the list, which would jarringly "jump" out of
            // its place.
            var changed = false;
            var items = (cart.items || []).map(function (current) {
              var info = infoByKey[current.key];
              if (!info) return { id: current.variant_id, quantity: current.quantity, properties: current.properties || {} };

              // Property-only (variant-less) lines have no "boxed version" to switch to
              // - but if the property was still set on them earlier (during personal
              // pickup), it's no longer relevant on delivery, so we clear it.
              if (info.propertyOnly) {
                var cleared = buildClearedPropertiesSpec(current);
                if (cleared) { changed = true; return cleared; }
                return { id: current.variant_id, quantity: current.quantity, properties: current.properties || {} };
              }

              // The "already on the boxed version" check is decided by matching
              // variant_ids (info.addonVariantId === current.variant_id below), not the
              // option value's text, because that's translatable -> the text match
              // would break for a different language setting.
              if (String(info.addonVariantId) === String(current.variant_id)) {
                return { id: current.variant_id, quantity: current.quantity, properties: current.properties || {} };
              }
              changed = true;
              return { id: info.addonVariantId, quantity: current.quantity, properties: current.properties || {} };
            });

            if (!changed) return;
            return performCartMutation([
              { endpoint: 'clear', body: {} },
              { endpoint: 'add', body: { items: reverseForCartAdd(items) } }
            ]);
          });
        }

        if (fulfillment === 'pickup') {
          return Promise.all(
            eligibleItems.map(function (item) {
              var handle = getHandleFromUrl(item.url);
              return getPackagingInfo(handle).then(function (info) {
                return info ? { item: item, info: info } : null;
              });
            })
          ).then(function (results) {
            var entries = results.filter(Boolean);
            entries.forEach(function (e) { renderSlot(e.item, e.info); }); // per-line toggle
            renderSummary(entries); // shared, informational summary above the checkout button
          });
        }

        // No shipping method chosen yet -> nothing to show, but we also clear any
        // leftover earlier personal-pickup property-only choices here too - see the
        // note at buildClearedPropertiesSpec. Order preservation matters here too.
        clearAllSlots();

        return Promise.all(
          eligibleItems.map(function (item) {
            var handle = getHandleFromUrl(item.url);
            return getPackagingInfo(handle).then(function (info) { return { item: item, info: info }; });
          })
        ).then(function (results) {
          var propertyOnlyKeys = {};
          results.forEach(function (r) { if (r.info && r.info.propertyOnly) propertyOnlyKeys[r.item.key] = true; });

          var changed = false;
          var items = (cart.items || []).map(function (current) {
            if (!propertyOnlyKeys[current.key]) {
              return { id: current.variant_id, quantity: current.quantity, properties: current.properties || {} };
            }
            var cleared = buildClearedPropertiesSpec(current);
            if (cleared) { changed = true; return cleared; }
            return { id: current.variant_id, quantity: current.quantity, properties: current.properties || {} };
          });

          if (!changed) return;
          return performCartMutation([
            { endpoint: 'clear', body: {} },
            { endpoint: 'add', body: { items: reverseForCartAdd(items) } }
          ]);
        });
      })
      .catch(function (err) {
        console.warn('[packaging-fulfillment-sync] Szinkronizálás sikertelen:', err);
      })
      .finally(function () {
        syncInProgress = false;
        if (syncQueued) {
          syncQueued = false;
          return sync();
        }
      });

    return syncPromise;
  }

  // Re-run on the theme's own cart event (our mutations trigger this too)
  document.addEventListener('cart:change', sync);

  // Re-run when the Pickeasy widget re-renders (e.g. on a shipping-method switch)
  var debounceTimer = null;
  var observer = new MutationObserver(function (records) {
    // Immediately (not debounced): the drawer's entire content gets replaced
    // synchronously after a cart change -> if the overlay is active at that point, it
    // must land on the NEW footer element right away, otherwise the not-yet-settled
    // content would flash for a moment before the debounced sync() below actually
    // rebuilds our UI.
    applyFooterOverlayState();

    // If we're currently "waiting to quiet down" before removing the overlay, and this
    // mutation happened INSIDE the drawer (e.g. the Pickeasy widget's own delayed
    // re-render), restart the wait - see the note on requestOverlayHide() above.
    if (overlayHidePending) {
      var drawer = document.querySelector('cart-drawer');
      var relevant = drawer && records.some(function (r) { return drawer.contains(r.target); });
      if (relevant) armOverlayHideTimer();
    }

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(sync, 150);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  function cloneFormDataWithOverrides(originalFormData, overrides) {
    var clone = new FormData();
    originalFormData.forEach(function (value, key) {
      clone.append(key, value);
    });
    Object.keys(overrides).forEach(function (key) {
      clone.set(key, overrides[key]);
    });
    return clone;
  }

  // The product page's "Add to cart" button submits the native <form
  // action="/cart/add"> as FormData (not JSON), with quantity N into ONE line. For a
  // packaging-option product, we split this into N separate /cart/add.js calls (1 piece
  // each, with a hidden "_instance" property, so Shopify doesn't merge them into the
  // same line) -> the cart then shows a separate line per piece, not merged as "2 pcs",
  // and each becomes independently switchable in the "mixed" panel below. If the
  // product isn't affected, or the quantity is 1, it returns null -> the caller runs
  // the original request unchanged.
  function trySplitProductFormAdd(formData) {
    var variantId = formData.get('id');
    var quantity = parseInt(formData.get('quantity') || '1', 10);
    if (!variantId || quantity <= 1) return Promise.resolve(null);

    var handle = getHandleFromUrl(window.location.href);
    return getPackagingInfo(handle).then(function (info) {
      var eligible = info && (String(info.baseVariantId) === String(variantId) || String(info.addonVariantId) === String(variantId));
      if (!eligible) return null;

      var sectionsParam = formData.get('sections');
      var lastResponse = null;
      var chain = Promise.resolve();

      for (var i = 0; i < quantity; i++) {
        (function (index) {
          chain = chain.then(function () {
            var overrides = {
              quantity: '1',
              'properties[_instance]': Date.now() + '-' + index
            };
            if (index === quantity - 1 && sectionsParam) {
              overrides.sections = sectionsParam;
            } else {
              overrides.sections = '';
            }
            var body = cloneFormDataWithOverrides(formData, overrides);
            return originalFetch(Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'X-Requested-With': 'XMLHttpRequest' },
              body: body
            }).then(function (res) {
              lastResponse = res;
            });
          });
        })(i);
      }

      return chain.then(function () { return lastResponse; });
    });
  }

  // Safety net: also react to the Pickeasy widget's own cart calls, in case they don't
  // run through the theme's "cart:change" event.
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';

    if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && init.body instanceof FormData) {
      return trySplitProductFormAdd(init.body).then(function (splitResponse) {
        var finalPromise = splitResponse ? Promise.resolve(splitResponse) : originalFetch(input, init);
        finalPromise.then(function () { setTimeout(sync, 200); }).catch(function () {});
        return finalPromise;
      });
    }

    var result = originalFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      result.then(function () { setTimeout(sync, 200); }).catch(function () {});
    }
    return result;
  };

  // On the product page, the "Helyben fogyasztod, vagy elviszed?" option (though hidden
  // by CSS - see theme.css) is natively set to the "Helyben fogyasztom" (free) variant -
  // but at the customer's request, the default choice must always be the take-away
  // (boxed, +600 Ft) version instead. Since the field is hidden, the customer wouldn't
  // be able to switch it manually, so we programmatically switch it on page load (and
  // also fire a real "change" event, so the theme's own variant-picker JS also updates
  // its associated hidden "id" field/price). The boxed option's label always contains a
  // "+" sign (e.g. "+600 Ft" / "Gift box (+600 Ft)"), the base version's never does -
  // this is what distinguishes the two buttons, independent of language.
  function forceDefaultPackagingSelection() {
    document.querySelectorAll('fieldset[data-option-name="helyben-fogyasztod-vagy-elviszed"]').forEach(function (fieldset) {
      var radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      var addonRadio = radios.find(function (r) {
        var label = r.nextElementSibling ? r.nextElementSibling.textContent : '';
        return label.indexOf('+') > -1;
      });
      if (addonRadio && !addonRadio.checked) {
        addonRadio.checked = true;
        addonRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      forceDefaultPackagingSelection();
      sync().then(watchCartPageReloadOverlay);
    });
  } else {
    forceDefaultPackagingSelection();
    sync().then(watchCartPageReloadOverlay);
  }

  window.packagingFulfillmentSyncRefresh = sync;
})();
